/**
 * アプリケーションのバージョン表示用定数。
 * リリースごとに手動で bump する (CLAUDE.md §2 リリース表と同期)。
 *
 * 直近リリース (2026-08-07): v1.0 マルチテナント化 (Phase 1-5) の production適用完了を受け、
 * user判断によりv0.3からv1.0へ表示バージョンを引き上げ。サブドメイン方式によるテナント単位
 * ログインID分離 (docs/design/v-future-tenant-scoped-login-subdomain.md) は別途の仕様変更として
 * 切り離し、v1.0の完了とは独立して扱う。TD-13/TD-14 (実害なし・見送り継続) やproduction D1の
 * DR訓練未実施等の運用ハードニング項目は残るが、機能としてのマルチテナント化は完了と判断。
 */
export const APP_VERSION = 'v1.0';
